import { DefaultSeo } from 'next-seo'

const DefaultSeoComponent = () => (
  <DefaultSeo
    title="音楽のクリエイターに楽曲制作を依頼できる | ONLIVE Studio"
    description="ONLIVE Studio は、音楽のクリエイターと、依頼者がマッチングできるサービスです。ONLIVE Studio には、プロデューサー、ミックスエンジニア、スタジオミュージシャンをはじめとした、業界の第一線で活躍している様々な音楽のクリエイターが登録されています。依頼者は自分に合ったクリエイターを検索し、ONLIVE Studio 上で依頼をすることが可能です。"
    // canonical="https://onlive.studio/"
    openGraph={
      {
        type: 'website',
        locale: 'ja_JP',
        // url: 'https://onlive.studio/',
        images: [{ url: 'https://onlive.studio/api/og/' }],
        siteName: 'ONLIVE Studio',
      }
    }
    twitter={
      {
        site: '@onlivestudio',
        cardType: 'summary_large_image',
      }
    }
    facebook={{ appId: '1398695963738160' }}
  />
)

export default DefaultSeoComponent
